module.exports = __webpack_public_path__ + "img/EATechWord1.8ecce6c4.png";